"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _deepObjectDiff = require("deep-object-diff");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports["default"] = function _default(_ref) {
  var _ref$fields = _ref.fields,
    fields = _ref$fields === void 0 ? [] : _ref$fields,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? function () {} : _ref$validate,
    _ref$initialValues = _ref.initialValues,
    initialValues = _ref$initialValues === void 0 ? {} : _ref$initialValues;
  return function (WrappedComponent) {
    var Form = /*#__PURE__*/function (_React$Component) {
      _inherits(Form, _React$Component);
      function Form() {
        _classCallCheck(this, Form);
        return _callSuper(this, Form, arguments);
      }
      _createClass(Form, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this$props = this.props,
            valid = _this$props.valid,
            values = _this$props.values,
            baseValues = _this$props.baseValues;
          if ((0, _isEqual2["default"])(prevProps.valid, valid) && (0, _isEqual2["default"])(prevProps.values, values)) {
            return;
          }
          if (valid) {
            this.props.onChange((0, _deepObjectDiff.updatedDiff)(baseValues || initialValues, values));
          }
        }
      }, {
        key: "render",
        value: function render() {
          var props = (0, _pick2["default"])(this.props, ['fields', 'settings', 'children', 'DataConnectorsPicker', 'inSidebar']);
          if (this.props.showHighlightedFields) {
            props.highlightedFields = Object.keys((0, _deepObjectDiff.updatedDiff)(this.props.baseValues || initialValues, this.props.values));
          }
          return /*#__PURE__*/_react["default"].createElement(WrappedComponent, props);
        }
      }]);
      return Form;
    }(_react["default"].Component);
    _defineProperty(Form, "propTypes", {
      valid: _propTypes["default"].bool,
      values: _propTypes["default"].object,
      onChange: _propTypes["default"].func,
      baseValues: _propTypes["default"].object,
      showHighlightedFields: _propTypes["default"].bool,
      inSidebar: _propTypes["default"].bool
    });
    _defineProperty(Form, "defaultProps", {
      onChange: function onChange() {}
    });
    return (0, _reduxForm.reduxForm)({
      form: 'templateSettingsForm',
      fields: fields,
      validate: validate,
      initialValues: initialValues
    })(Form);
  };
};